export const getCheckoutUrl = () => '/business/subscriptions/create_stripe_customer_and_checkout';

export const getTransactionsUrl = (workspaceId: string) => `business/workspaces/${workspaceId}/transactions`;

export const getCancelSubscriptionUrl = (workspaceId: string) =>
  `business/workspaces/${workspaceId}/subscriptions/manage_subscription_url`;

export const getBillingStatsUrl = () => 'business/subscriptions/billing_stats';
